export type LatLng = {
  lat: number;
  lng: number;
}

export function latLngToDistance(start : LatLng, end : LatLng) {
  const lat1 = start.lat,
        lat2 = end.lat,
        lon1 = start.lng,
        lon2 = end.lng;

  const R = 3958.8; // miles
  const φ1 = lat1 * Math.PI/180; // φ, λ in radians
  const φ2 = lat2 * Math.PI/180;
  const Δφ = (lat2-lat1) * Math.PI/180;
  const Δλ = (lon2-lon1) * Math.PI/180;

  const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ/2) * Math.sin(Δλ/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

  return R * c; // in miles
}